import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';
import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { useIsBottomFromTenantAdmin } from 'shared/permissions/useIsBottomFromTenantAdmin';
import ConfirmationUnlinkButtonDialog from 'components/ui/feedback/ConfirmationButtonUnlink';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { IProduct } from '../../types';
import { ProductExams } from '../card/ProductExamsCard';

interface CostAnalysisTabProps {
  product: IProduct;
  handleRemoveLink: any;
}

function CostAnalysisTab({ product, handleRemoveLink }: CostAnalysisTabProps) {
  const { t } = useTranslation();
  const isTenantAdminBottom = useIsBottomFromTenantAdmin();

  return (
    <>
      <EnhancedCard title={t('global.costs')}>
        <div className="w-full flex flex-wrap justify-center p-4">
          {product &&
            [
              { field: 'laboratories', link: '/tenant/topology/lab/' },
              { field: 'operational_units', link: '/tenant/topology/operationalunit/' },
              { field: 'sectors', link: '/tenant/topology/sector/' },
              { field: 'workstations', link: '/tenant/cost-analysis/workstations/' },
              { field: 'equipments', link: '/tenant/equipments/' }
            ].map((e) => (
              <div
                key={e.field}
                className="w-full sm:w-1/2 lg:w-1/5 pl-4 first:pl-0 border-r last:border-0">
                <div className="flex justify-start items-center mt-4 mb-2">
                  <Typography variant="body1" component="div" fontWeight={600}>
                    {t(`global.${e.field}`)}
                  </Typography>
                  {/* (NON SI PUO AGGIUNGERE DA - Product - SOLO DA PRODUCT-WAREHOUSE) <IconButton color="primary" onClick={() => setMode(e.field)}>
                   <AddCircleOutlineIcon />
                 </IconButton> */}
                </div>
                <List dense={true} className="ml-0">
                  {product[e.field] &&
                    product[e.field].map((entity, i) => (
                      <ListItem
                        key={i}
                        sx={{ padding: 0 }}
                        secondaryAction={
                          <div key={i}>
                            <NavLink to={`${e.link}${entity.id}`}>
                              <IconButton edge="end">
                                <VisibilityIcon />
                              </IconButton>
                            </NavLink>
                            {isTenantAdminBottom && (
                              <ConfirmationUnlinkButtonDialog
                                iconButton={true}
                                id={entity.id}
                                pars={e.field}
                                handleUnlink={handleRemoveLink}
                              />
                            )}
                          </div>
                        }>
                        <ListItemButton>
                          <ListItemText primary={entity.code} secondary={entity['description']} />
                          <Divider variant="inset" component="li" />
                        </ListItemButton>
                      </ListItem>
                    ))}
                </List>
              </div>
            ))}
        </div>
      </EnhancedCard>

      {product && <ProductExams productId={product.id} />}
    </>
  );
}

export default CostAnalysisTab;
